import StartImport from '@/components/Imports/StartImport.vue';
import ModalComponent from '@/pages/app/MI/components/Modal.vue';
import ImportDetail from '@/components/Imports/ImportDetail.vue';
import { EditMenuItem } from 'components/NavBar.vue';

import ImportController from '@/controller/importcontroller.js';
const controller = new ImportController();

export default {
  components: {
    'start-import': StartImport,
    'import-modal': ModalComponent,
    'import-detail': ImportDetail
  },
  data () {
    return {
      importController: controller,
      allowImport: false,
      
      showImport: false,
      showImportStart: false,
      importId: null,
      importMenuItemAdded: false
    };
  },
  async created(){
    if(this.preventImport){
      return;
    }
    if(this.fetchDestination){
      let destinations = await controller.GetDestinations(this.fetchDestination);
      if(destinations && destinations.length > 0){
        this.allowImport = true;
      }
    }
  },
  methods: {
    importCloseCallback(){
      this.showImportStart = false;
      this.showImport = false;
      this.importId = null;
    },
    importManualClose () {
      this.$refs.importModal.manualClose();
      this.importCloseCallback();
    },
    openImportModal(){
      this.showImport = true;
      this.showImportStart = true;
    },
    openImportDetail(autoid){
      this.showImportStart = false;
      this.importId = autoid;
    },
    addImportMenuItem(val){
      if(val){
        this.datasetActions.unshift(new EditMenuItem(this.$t('import'), this.openImportModal, 'editmenu-import'));
      }
    }
  },
  watch: {
    allowImport: {
      handler: function(val, oldval) {
        if(this.importMenuItemCustomIndex == null){
          this.addImportMenuItem(val);
      }
    }
  },
  datasetActions: {
    handler: function(val, oldval) {
      if(this.importMenuItemAdded){
        return;
      }
      if(this.importMenuItemCustomIndex != null){
        if (val && val.length > 0 && this.allowImport) {
          this.datasetActions.splice(this.importMenuItemCustomIndex, 0, new EditMenuItem(this.$t('import'), this.openImportModal, 'editmenu-import'));
          this.importMenuItemAdded = true;
        } else if (val && val.length === 0 && this.allowImport) {
          this.datasetActions.push(new EditMenuItem(this.$t('import'), this.openImportModal, 'editmenu-import'));
          this.importMenuItemAdded = true;
        }
      }
    }
  }
}
};